import React, { forwardRef, useImperativeHandle, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as virActions from "src/actions/virActions";
import { RESET_ADDRESS_SEARCH } from "src/types/actions";
import getCountryFromURL from "../../utils/getCountryFromUrl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@packages/ui";
import _ from "lodash";

import { AU_SEARCHADDRESS, NZ_SEARCHADDRESS } from "../../utils/constants";

//parent may need to mannualy set the input value
//so use forwardRef
const PlacesAutoComplete = (
  {
    disabled,
    onAddressChange,
    incidentAddress,
    googleApiKey,
    onPlaceSelected,
    label,
    selectedChoice,
    options = {},
    ...params
  },
  ref
) => {
  // const virAddress = useSelector(
  //   (state) => state.vir.athenaVirDetail?.data.IncidentDetails?.Address
  // );
  const athenaVirDetailPatch = useSelector((state) => state.vir.athenaVirDetailPatch?.data);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail?.data);
  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const previousData = resubmitFlag ? athenaVirDetail : athenaVirDetailPatch;
  const virAddress =
    params?.page === "thirdParty"
      ? previousData?.ThirdPartyDetail?.Address
      : previousData?.IncidentDetails?.Address;

  const [inputValue, setInputValue] = useState(incidentAddress || "");
  const [suggestions, setSuggestions] = useState([]);
  const [currentKey, setCurrentKey] = useState("");
  const virState = useSelector((state) => state.vir);
  const dispatch = useDispatch();
  const country = getCountryFromURL();

  useEffect(() => {
    onAddressChange(inputValue);
  }, [inputValue]);

  useEffect(() => {
    dispatch({ type: RESET_ADDRESS_SEARCH });
  }, []);
  useEffect(() => {
    setSuggestions(virState.addressSuggestions ?? []);
  }, [virState.addressSuggestions]);

  useEffect(() => {
    setInputValue(incidentAddress || "");
  }, [incidentAddress]);

  useImperativeHandle(
    ref,
    () => ({
      //method that parent can invoke
      setAutoCompleteValue: (value) => {
        setInputValue(value);
      },
    }),
    []
  );

  const handleAddressInputChange = (e) => {
    if (!e) {
      return; // if the change is not triggered by user's input, ignore
    }
    const value = e.target.value;
    setInputValue(value);
    if (value?.toString().replace(/\s/g, "").length > 6 && currentKey != "Backspace") {
      const selectedCountry = country || virState.userLocation?.country;
      dispatch(
        virActions.searchAddress({
          token: virState.athenaAuth.authorization,
          address: value,
          countryCode: country,
          method: selectedCountry === "AU" ? AU_SEARCHADDRESS : NZ_SEARCHADDRESS,
        })
      );
    }
    if (inputValue) {
      onAddressChange(inputValue);
    }
  };

  return (
    <>
      <Autocomplete
        freeSolo
        filterOptions={(options, state) => options}
        disableClearable
        disabled={disabled}
        options={suggestions}
        inputValue={inputValue}
        getOptionLabel={(option) => (_.isObject(option) ? option.label : option ? option : "")}
        renderInput={(params) => (
          <TextField
            fullWidth
            {...params}
            label={label || "Incident Location"}
            variant="outlined"
            onKeyDown={(event) => {
              setCurrentKey(event.key);
            }}
          />
        )}
        onInputChange={(event) => {
          handleAddressInputChange(event);
        }}
        onChange={(_, data) => {
          setInputValue(data.label);
          setSuggestions([]);
          selectedChoice(data.label);
        }}
      />
    </>
  );
};

export default forwardRef(PlacesAutoComplete);
